import { Map, Feature } from 'ol';
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter } from '../Activity/Activity';
import { ICAMSContact, ContactListConfig } from '../Contacts/ContactsModels';
import { Photos } from '../Photos/Photos';
import { MapLayerGroupType } from '../Models/MapConfigModels';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Tasks_Assign } from './Tasks_Assign';
import { Tasks_Edit } from './Tasks_Edit';
import * as AuthModel from '../Models/AuthModel';
import { Tasks_Groups } from './Tasks_Groups';
import { Tasks_Complete } from './Tasks_Complete';
import { PredefinedModalEnum, ModalPrompts } from '../Utility/ModalPrompts';

// LUT table 
export class ContactTypeModel { ListName: string; ContactRed: string; ContactTypeLUT: string; }
export type tasksCompletePanelCallback = (result: IAPIResult) => any;

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Tasks {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();
    private newTaskWizardState: { featureSelectedCAMSKey?: ICAMSKey, featuresSelected?: Array<Feature>, drawFeature?: Feature };
    private subscriptionSingleFeatureSelected;
    private subscriptionMultipleFeaturesSelected;
    private subscriptionRectangleSelectionComplete;
    private subscriptionDrawCompleted;
    private Tasks_Assign: Tasks_Assign = new Tasks_Assign();
    private Tasks_Edit: Tasks_Edit;
    private Tasks_Groups: Tasks_Groups;
    private Tasks_Complete: Tasks_Complete;

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        self.Tasks_Groups = new Tasks_Groups(self.Tasks_Assign);
        self.Tasks_Edit = new Tasks_Edit(self.Tasks_Assign);
        self.Tasks_Complete = new Tasks_Complete();

        $('#newTaskCloseBtn').on('click', function () { self.newTaskWizard_Close() });
        $('#newTask_SaveBtn').on('click', function () { self.newTaskWizard_Save() });
        $('#newTask_CancelBtn').on('click', function () { self.newTaskWizard_Cancel() });
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openTaskViewPanel = (camsKey: ICAMSKey, showClass: string = 'show', closeCallback: Function, isConditionSurvey: Boolean): void => {
        const self = this;
        self.Tasks_Edit.openTaskViewPanel(camsKey, showClass, closeCallback, isConditionSurvey);
    }

    public openTaskCreateForm = (camsKeys: Array<ICAMSKey>, callback: Function): void => {
        const self = this;
        self.Tasks_Edit.openTaskCreateForm(camsKeys, callback);
    }

    public openTaskEditForm = (camsKey: ICAMSKey, callback: Function): void => {
        const self = this;
        self.Tasks_Edit.openTaskEditForm(camsKey, callback);
    }

    public openTaskGroupViewPanel = (camsKey: ICAMSKey, showClass: string = 'show', closeCallback: Function): void => {
        const self = this;
        self.Tasks_Groups.openTaskGroupViewPanel(camsKey, showClass, closeCallback);
    }

    public openTaskGroupCreatePanel = (taskIDs: Array<string>): void => {
        const self = this;
        self.Tasks_Groups.openTaskGroupCreatePanel(taskIDs)
    }

    public openTaskGroupEditPanel = (camsKey: ICAMSKey): void => {
        const self = this;
        self.Tasks_Groups.openTaskGroupEditPanel(camsKey);
    }

    public openAcceptPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL, viewData, submitURL;
        if (camsKey.featureType == FeatureType.TaskGroup) {
            viewURL = window.G_SITEFOLDERNAME +"/Tasks/AcceptGroupView";
            viewData = { taskGroupID: camsKey.code };
            submitURL = window.G_SITEFOLDERNAME + "/Tasks/AcceptGroupTask";
        }
        else {
            viewURL = window.G_SITEFOLDERNAME + "/Tasks/AcceptView";
            viewData = { taskID: camsKey.code };
            submitURL = window.G_SITEFOLDERNAME + "/Tasks/AcceptTask";
        }

        // *******************************************************************************************************//
        // SUMBIT //
        function promptYesNoModal() {

            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.TaskAcceptWarning }).then(r => {
                if (r.yes == true) {
                    loadForm();
                }
                else {
                }
            }).catch(e => { });
        }

        // PROMPT the user first
        let isAlreadyAccepted = $("#isAlreadyAccepted").data("isalreadyaccepted");
        if (isAlreadyAccepted == true) {
            promptYesNoModal();
        } else {
            loadForm();
        }

        function loadForm() {
            Utilities.BlockUI();
            $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
                Utilities.UnBlockUI();
                Utilities.GetModal('#taskAcceptModal', ModalAction.Create);

                // Get form validation
                Utilities.InitFormValidation($("#taskAcceptForm"));

                $('#taskAcceptSubmitBtn').on('click', function (evt) {
                    evt.preventDefault();

                    // Validate
                    let form: any = $('#taskAcceptForm');
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($("#taskAcceptModal .modal-content"));
                    let formData = new FormData(<any>$('#taskAcceptForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: submitURL,
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Accepted task!');
                                    events.bus.publish(events.eventTaskUpdated(camsKey));
                                }
                                else {
                                    toastr.error('Failed to accept task!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.GetModal('#taskAcceptModal', ModalAction.Hide);
                                Utilities.UnBlockUI($("#taskAcceptModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                });

                $('#taskAcceptCancelBtn').on('click', function (evt) {
                    Utilities.GetModal('#taskAcceptModal', ModalAction.Hide);
                });
            });
        }
    }

    public openRejectPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL, viewData, submitURL, viewForm, viewModal, viewSubmit, viewCancel;
        if (camsKey.featureType == FeatureType.TaskGroup) {
            viewForm = "#taskGroupRejectForm";
            viewModal = "#taskGroupRejectModal";
            viewSubmit = "#taskGroupRejectSubmitBtn";
            viewCancel = "#taskGroupRejectCancelBtn";
            viewURL = window.G_SITEFOLDERNAME + "/Tasks/RejectGroupView";
            viewData = { taskGroupID: camsKey.code };
            submitURL = "/Tasks/RejectGroupTask";
        }
        else {
            viewForm = "#taskRejectForm";
            viewModal = "#taskRejectModal";
            viewSubmit = "#taskRejectSubmitBtn";
            viewCancel = "#taskRejectCancelBtn";
            viewURL = window.G_SITEFOLDERNAME + "/Tasks/RejectView";
            viewData = { taskID: camsKey.code };
            submitURL = "/Tasks/RejectTask";
        }

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
       
            Utilities.GetModal(viewModal, ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($(viewForm));

            $(viewSubmit).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $(viewForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(viewModal + " .modal-content"));
                let formData = new FormData(<any>$(viewForm)[0]);

                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Rejected task!');
                                events.bus.publish(events.eventTaskUpdated(camsKey));
                            }
                            else {
                                toastr.error('Failed to reject task!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal(viewModal, ModalAction.Hide);
                            Utilities.UnBlockUI($(viewModal + " .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $(viewCancel).on('click', function (evt) {
                Utilities.GetModal(viewModal, ModalAction.Hide);
            });
        });
    }

    public openCompletePanel = (camsKey: ICAMSKey, showCancelBtns: Boolean, callback: tasksCompletePanelCallback): void => {
        const self = this;
        self.Tasks_Complete.openCompletePanel(camsKey, showCancelBtns, callback);
    }

    public openCompleteGroupPanel = (camsKey: ICAMSKey): void => {
        const self = this;
        self.Tasks_Complete.openCompleteGroupPanel(camsKey);
    }

    public openAssignPanel = (camsKeys: Array<ICAMSKey>, options, callback: Function): void => {
        var self = this;
        self.Tasks_Assign.openAssignPanel(camsKeys, options, callback);
    }

    public openPoolAddPanel = (camsKeys: Array<ICAMSKey>): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/PoolAddView";
        let submitURL = "/Tasks/PoolAdd";
        let taskIDs: Array<string> = [];
        let taskGroupIDs: Array<string> = [];
        camsKeys.forEach(c => {
            if (c.featureType == FeatureType.Task) {
                taskIDs.push(c.code);
            }
            else {
                taskGroupIDs.push(c.code);
            }
        });
        let viewData = { taskIDs: taskIDs, taskGroupIDs: taskGroupIDs };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskPoolAddModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskPoolAddForm"));

            $('#taskPoolAddSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskPoolAddForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskPoolAddModal .modal-content"));
                let formData = new FormData(<any>$('#taskPoolAddForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Add task to pool!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to add task to pool!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskPoolAddModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskPoolAddModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskPoolAddCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskPoolAddModal', ModalAction.Hide);
            });
        });
    }

    public openTaskGroupTasksPanel = (camsKeys: Array<ICAMSKey>): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/TaskGroupTasksView";
        let submitURL = "/Tasks/TaskGroupTasks";
        let taskIDs: Array<string> = [];
        let taskGroupIDs: Array<string> = [];
        camsKeys.forEach(c => {
            if (c.featureType == FeatureType.Task) {
                taskIDs.push(c.code);
            }
        });
        let viewData = { taskIDs: taskIDs, taskGroupIDs: taskGroupIDs };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskGroupTasksModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskGroupTasksForm"));

            $('#taskGroupTasksNewTaskGroupBtn').on('click', function (evt) {
                Utilities.GetModal('#taskGroupTasksModal', ModalAction.Hide);
                events.bus.publish(events.eventOpenTaskGroupCreatePanel(taskIDs));
            });

            $('#taskGroupTasksSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskGroupTasksForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskGroupTasksModal .modal-content"));
                let formData = new FormData(<any>$('#taskGroupTasksForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Grouped tasks!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to group tasks!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskGroupTasksModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskGroupTasksModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskGroupTasksCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskGroupTasksModal', ModalAction.Hide);
            });
        });
    }

    public openTaskUnGroupTasksPanel = (camsKeys: Array<ICAMSKey>): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/TaskUnGroupTasksView";
        let submitURL = "/Tasks/TaskUnGroupTasks";
        let taskIDs: Array<string> = [];
        let taskGroupIDs: Array<string> = [];
        camsKeys.forEach(c => {
            if (c.featureType == FeatureType.Task) {
                taskIDs.push(c.code);
            }
        });
        let viewData = { taskIDs: taskIDs, taskGroupIDs: taskGroupIDs };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskUnGroupTasksModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskUnGroupTasksForm"));

            $('#taskUnGroupTasksSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskUnGroupTasksForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskUnGroupTasksModal .modal-content"));
                let formData = new FormData(<any>$('#taskUnGroupTasksForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Ungrouped tasks!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to ungroup tasks!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskUnGroupTasksModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskUnGroupTasksModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskUnGroupTasksCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskUnGroupTasksModal', ModalAction.Hide);
            });
        });
    }

    public openTaskReGroupTasksPanel = (camsKeys: Array<ICAMSKey>): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/TaskReGroupTasksView";
        let submitURL = "/Tasks/TaskReGroupTasks";
        let taskIDs: Array<string> = [];
        let taskGroupIDs: Array<string> = [];
        camsKeys.forEach(c => {
            if (c.featureType == FeatureType.Task) {
                taskIDs.push(c.code);
            }
        });
        let viewData = { taskIDs: taskIDs, taskGroupIDs: taskGroupIDs };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskReGroupTasksModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskReGroupTasksForm"));

            $('#taskReGroupTasksSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskReGroupTasksForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskReGroupTasksModal .modal-content"));
                let formData = new FormData(<any>$('#taskReGroupTasksForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Regrouped tasks!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to regroup tasks!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskReGroupTasksModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskReGroupTasksModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskReGroupTasksCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskReGroupTasksModal', ModalAction.Hide);
            });
        });
    }

    public openOtherStatusTasksPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/TaskOtherStatusView";
        let submitURL = "/Tasks/UpdateTaskStatus";

        var taskID, taskGroupID;
        if (camsKey.featureType == FeatureType.Task) taskID = camsKey.code; else taskGroupID = camsKey.code;
        let viewData = { taskID: taskID, taskGroupID: taskGroupID };


        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskOtherStatusModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskOtherStatusForm"));

            $('#taskOtherStatusSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskOtherStatusForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskOtherStatusModal .modal-content"));
                let formData = new FormData(<any>$('#taskOtherStatusForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Status set!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to set status!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskOtherStatusModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskOtherStatusModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskOtherStatusCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskOtherStatusModal', ModalAction.Hide);
            });
        });
    }

    public openTaskSignOffPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/SignOffTasksView";
        let submitURL = "/Tasks/SignOffTasks";

        var taskID, taskGroupID;
        if (camsKey.featureType == FeatureType.Task) taskID = camsKey.code; else taskGroupID = camsKey.code;
        let viewData = { taskID: taskID, taskGroupID: taskGroupID };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskSignOffModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskSignOffForm"));

            $('#taskSignOffSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskSignOffForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("taskSignOffModal .modal-content"));
                let formData = new FormData(<any>$('#taskSignOffForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Signed-off tasks!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to sign-off tasks!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskSignOffModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskSignOffModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskSignOffCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskSignOffModal', ModalAction.Hide);
            });
        });
    }

    public openTaskInspectPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/InspectTasksView";
        let submitURL = "/Tasks/InspectTasks";

        var taskID, taskGroupID;
        if (camsKey.featureType == FeatureType.Task) taskID = camsKey.code; else taskGroupID = camsKey.code;
        let viewData = { taskID: taskID, taskGroupID: taskGroupID };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskInspectModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskInspectForm"));

            $('#taskInspectPassBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskInspectForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                $('#taskInspectForm [name="SavePassFail"]').val('pass');
                doSubmit();
            });

            $('#taskInspectFailBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskInspectForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                $('#taskInspectForm [name="SavePassFail"]').val('fail');
                doSubmit();
            });

            $('#taskInspectSaveBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskInspectForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                $('#taskInspectForm [name="SavePassFail"]').val('save');
                doSubmit();
            });

            function doSubmit() {
                Utilities.BlockUI($("taskInspectModal .modal-content"));
                let formData = new FormData(<any>$('#taskInspectForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Inspected tasks!');
                                events.bus.publish(events.eventTaskUpdated(null));
                            }
                            else {
                                toastr.error('Failed to inspect tasks!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskInspectModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("taskInspectModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#taskInspectCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskInspectModal', ModalAction.Hide);
            });
        });
    }

    public openAssignedTasksForm = (contactRef: string, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(window.G_SITEFOLDERNAME +'/TaskManagement/AssignedTasks', { contactRef: contactRef }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskManagementAssigedTasksModal', ModalAction.Create);
            // Instantiate tables and then get task data 
            ($('#taskManagementAssignedTasksTaskTable') as any).bootstrapTable();
            ($('#taskManagementAssignedTasksTaskGroupTable') as any).bootstrapTable();
            self.GetAssignedTasks(contactRef as string);

            // Contact Btn
            $('#taskManagementAssigedTasksContactListBtn').on('click', function () {
                function callback(c: Array<ICAMSContact>) {
                    $('#taskManagementAssigedTasksModal [name="ContactRef"]').val(c[0].ContactRef);
                    $('#taskManagementAssigedTasksModal [name="ContactRefListName"]').val(c[0].ListName);
                    self.GetAssignedTasks(c[0].ContactRef);
                }

                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));
            });

            // submit
            $('#taskManagementAssigedTasksSubmitBtn').on('click', function (evt) {
                if (callback != null) {
                    var contactRef = $('#taskManagementAssigedTasksModal [name="ContactRef"]').val();
                    var contactRefListName = $('#taskManagementAssigedTasksModal [name="ContactRefListName"]').val();
                    callback(contactRef, contactRefListName);
                }
                Utilities.GetModal('#taskManagementAssigedTasksModal', ModalAction.Hide);
            });


            // Cancel
            $('#taskManagementAssigedTasksCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskManagementAssigedTasksModal', ModalAction.Hide);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA
    private GetAssignedTasks = (contactRef: string): void => {
        const self = this;

        Utilities.BlockUI($('#taskManagementAssignedTasksTaskTable'));
        $.post(window.G_SITEFOLDERNAME + "/TaskManagement/GetTaskManagementAssignedTasks", { contactRef: contactRef },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var tasks = JSON.parse(result.data.tasks);
                        ($('#taskManagementAssignedTasksTaskTable') as any).bootstrapTable('load', tasks);

                        var taskGroups = JSON.parse(result.data.taskGroups);
                        ($('#taskManagementAssignedTasksTaskGroupTable') as any).bootstrapTable('load', taskGroups);

                        var totalTime = 0;
                        tasks.forEach(t => { totalTime += t.TimeEst; });
                        $('#taskManagementTotalTime').val(totalTime.toString());
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#taskManagementAssignedTasksTaskTable'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        self.Tasks_Edit.deleteEntity(data, callback);
    }

    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public newTaskWizard_Start = (allowLand: boolean): void => {
        const self = this;

        if (self.map.getView().getZoom() < 15) {
            Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "TS_Toastr_ZoomCloserError" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
            return;
        }

        // Reset everything
        this.newTaskWizardState = {};
        $('#newTask_Message1').show();
        $('#newTask_Message2').hide();
        $('#newTask_SaveBtn').hide();
        $('#newTaskPanel').addClass('show');
        $('#newTask_CancelBtn').hide();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
        if (self.subscriptionMultipleFeaturesSelected) self.subscriptionMultipleFeaturesSelected();
        if (self.subscriptionRectangleSelectionComplete) self.subscriptionRectangleSelectionComplete();
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
    
        // START: If a feature is provided then skip step 1, otherwise do step 1
        let selectableLayers = [FeatureType.Route, FeatureType.Maint, FeatureType.Infra];
        if (self.authModel.enableTasksOnIssuesOnly == true) selectableLayers = [FeatureType.Maint];
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: selectableLayers };

        //turn on layers
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Route, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.MyMaint, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Maint, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Infra, true]));

        if (allowLand) {
            events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Land, true]));
            interactionData.selectableLayers.push(FeatureType.Land);
        }

        events.bus.publish(events.eventStartSingleSelection(interactionData));

        // STEP 1: Select Geom
        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            $('#newTask_Message1').hide();

            $('#newTask_SaveBtn').show();
            $('#newTask_Message2').show();
            $('#newTask_CancelBtn').show();
        });

        /*self.subscriptionRectangleSelectionComplete = events.bus.subscribe(events.eventRectangleSelectionComplete, m => {
            $('#newTask_Message1').hide();

            $('#newTask_SaveBtn').show();
            $('#newTask_Message2').show();
            $('#newTask_CancelBtn').show();
        });*/
    }

    private newTaskWizard_Save = (): void => {
        const self = this;
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        if (self.subscriptionRectangleSelectionComplete) self.subscriptionRectangleSelectionComplete();
        events.bus.publish(events.eventGetSelectedFeatures(function (features) {
            let data: Array<ICAMSKey> = [];
            features.forEach(f => { data.push(self.map.convertFeatureToCAMSKey(f)); });
            self.openTaskCreateForm(data, null);
            self.newTaskWizard_Close();
        }));
    }

    private newTaskWizard_Close = (): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        if (this.subscriptionRectangleSelectionComplete) this.subscriptionRectangleSelectionComplete();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
    }

    private newTaskWizard_Cancel = (): void => {
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        if (this.subscriptionRectangleSelectionComplete) this.subscriptionRectangleSelectionComplete();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
        this.newTaskWizard_Start($('#newTask_Message1').data('allow-land'));
    }

    // ----------------------------------------------------------- //
    // MISC
    private contactTypeChanged = (contactEl: JQuery<HTMLElement>, contactTypeStr: string, selectContactRef: string = null): void => {
        // Remove all options
        contactEl.find('option').remove().end();

        const self = this;
        Utilities.BlockUI(contactEl);
        let data = { contactType: contactTypeStr, skip: 0, take: 100, alsoIncludeContactRef: selectContactRef }; // This makes sure the list we get back is liomited to 100 items, and that the selected contac tis also included

        $.post('/Contacts/GetContactsByType', data,
            function (data) {
                try {
                    var dataObject: Array<any> = jQuery.parseJSON(data);

                    dataObject.forEach(i => {
                        var selected = "";
                        if (selectContactRef != null && selectContactRef == i.ContactRef) selected = "selected";
                        contactEl.append($("<option " + selected + "></option>").attr("value", i.ContactRef).text(i.ListName));
                    });
                }
                catch (err) {
                    console.log(err);
                }
                finally {
                    Utilities.UnBlockUI(contactEl);
                }
            },
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private showActivityInPopover = (el: JQuery<HTMLElement>, data: ICAMSKey, taskActivityType: ActivityListType, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.uid.toString(), ActivityListType: taskActivityType, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([el, model, parentModal]));
    }

}




